import { Box, Button, Grid, InputLabel, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import ReactModal from "../../../../Components/Modal/Modal";
import { useStyle } from "../HRMSetup/Departments/department-styles";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { createLoanRequest } from "../../../../Redux/Actions/LoanRequests";
import { successNotify, errorNotify } from "../../../../Utils/toast";
import {
  formatAmountInputDisplay,
  parseAmountNumber,
  preventInvalidAmountKeys,
} from "../../../../Utils/helper";

const AddLoanRequestModal = ({ modalOpen, setModalOpen, onSuccess }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector(
    (state) => state.createLoanRequest,
  );
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");

  const { handleSubmit } = useForm();

  useEffect(() => {
    if (success) {
      successNotify("Loan request submitted successfully!");
      setAmount("");
      setDescription("");
      dispatch({ type: "CREATE_LOAN_REQUEST_RESET" });
      setModalOpen(false);
      if (onSuccess) {
        onSuccess();
      }
    }
    if (error) {
      errorNotify(error);
      dispatch({ type: "CLEAR_ERRORS" });
    }
  }, [success, error]);

  const handleClose = () => {
    setModalOpen(false);
    setAmount("");
  };

  const onSubmitHandler = handleSubmit(() => {
    const parsed = parseAmountNumber(amount);
    if (!parsed || parsed <= 0) {
      errorNotify("Please enter a valid loan amount greater than 0");
      return;
    }
    const payload = { amount: parsed };
    if (description.trim()) {
      payload.description = description.trim();
    }
    dispatch(createLoanRequest(payload));
  });

  return (
    <ReactModal
      open={modalOpen}
      setOpen={setModalOpen}
      title="Apply for Loan"
      size={500}
    >
      <Form onSubmit={onSubmitHandler}>
        <Box>
          <Grid container>
            <Grid item md={12}>
              <Box sx={{ my: 2 }}>
                <InputLabel className={classes.department_label}>
                  Loan Amount (Rs)
                </InputLabel>
                <TextField
                  sx={{ mt: 1 }}
                  placeholder="Enter amount in Rs"
                  fullWidth
                  type="text"
                  inputProps={{ inputMode: "decimal" }}
                  className={classes.inputContainer}
                  value={amount}
                  onKeyDown={preventInvalidAmountKeys}
                  onChange={(e) =>
                    setAmount(formatAmountInputDisplay(e.target.value))
                  }
                />
              </Box>
            </Grid>
            <Grid item md={12}>
              <Box sx={{ my: 1 }}>
                <InputLabel className={classes.department_label}>
                  Description (optional)
                </InputLabel>
                <TextField
                  sx={{ mt: 1 }}
                  placeholder="Add any details about your loan request"
                  fullWidth
                  className={classes.inputContainer}
                  rows={4}
                  multiline
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Box sx={{ display: "flex", gap: "10px" }}>
            <Button
              variant="contained"
              type="button"
              className={classes.cancelBtn}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              type="submit"
              disabled={loading}
              className={classes.createBtn}
            >
              {loading ? <Spinner size="sm" animation="border" /> : "Submit"}
            </Button>
          </Box>
        </Box>
      </Form>
    </ReactModal>
  );
};

export default AddLoanRequestModal;
